import styled from 'styled-components'

export const LoaderContainer = styled.div`
  width: 100%;
  margin-top: 40px;

  display: flex;
  justify-content: center;
  align-items: center;
`
